import { render, staticRenderFns } from "./epidemicPeopleCard.vue?vue&type=template&id=3983c1ef&scoped=true&"
import script from "./epidemicPeopleCard.vue?vue&type=script&lang=js&"
export * from "./epidemicPeopleCard.vue?vue&type=script&lang=js&"
import style0 from "./epidemicPeopleCard.vue?vue&type=style&index=0&id=3983c1ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983c1ef",
  null
  
)

export default component.exports